import {
  ArrowContainer,
  CenterSideContainer,
  Circle,
  Container,
  EmptyMeetingRoomList,
  FilterContainer,
  FilterItemContainer,
  MeetingRoomContainer,
  MeetingRoomListContainer,
  MeetingRoomListWrapper,
  MeetingRoomReservationListContainer,
  PageDate,
  PageHeader,
  PageTitle,
  TimeTableLayout,
  TimeTableScrollContainer,
} from "./index.styles";
import UI from "@mile-meeting/mile-ui";
import * as Modals from "uis/modal";
import LocationFilter, { LocationDataType } from "uis/Filters/MeetingRoomLocationFilter/MeetingRoomLocationFilter";
import { MeetingRoomFilter } from "uis/Filters";
import MeetingRoomCard from "./component/meeting-room-card";
import TimeTableUnderLayout, { getMinutesSince7AM } from "./timetable-layout";
import MeetingRoomReservationList from "./meeting-room-reservation-list";
import { useEffect, useRef, useState } from "react";
import {
  getBuildingListForLocation,
  getMeetingRoomList,
  TLocationFilter,
  TMeetingRoom,
} from "apis/meetings/meeting-room";
import ReservationModal from "./reservation-modal";
import { TBuilding } from "types/building.types";
import TimeSelectorModal from "./component/time-selector-modal";
import { getMeetingReservationList, TReservation } from "apis/meetings/meeting-reservation";
import { TColor } from "./component/reservation-item";
import EditRsvModal from "./edit-modal";
import { checkOverlap, getScrollPosition } from "./utils";
import { RepeatReservationConditionalOption } from "uis/modal/repeat-edit-conditinal-modal";
import TimeLabelList from "uis/BookingList/TimeLabelList";
import { MeetingRoomCardSkeleton, TimeTableSkeleton } from "uis/BookingList";

const BookingList = () => {
  const [meetingRoomList, setMeetingRoomList] = useState<TMeetingRoom[]>([]);
  const [openReserVationModal, setOpenReserVationModal] = useState<boolean>(false);
  const [locationFilter, setLocationFilter] = useState<TLocationFilter[]>([]);
  const [buildingInfo, setBuildingInfo] = useState<(TBuilding | null)[]>([]);
  const [filteredMeetingRoomList, setFilteredMeetingRoomList] = useState<TMeetingRoom[]>([]);
  const [openMeetingRoomFilter, setOpenMeetingRoomFilter] = useState<boolean>(false);
  const [showMeetingRoomList, setShoMeetingRoomList] = useState<TMeetingRoom[]>([]);
  const [showStartIndex, setShowStartIndex] = useState<number>(0);
  const [showEndIndex, setShowEndIndex] = useState<number>(7);
  const [openTimeSelector, setOpenTimeSelector] = useState<boolean>(false);
  const [filteredDate, setFilteredDate] = useState<Date>(new Date());
  const [rsvList, setRsvList] = useState<TReservation[][]>([]);
  const [openEditRsvModal, setOpenEditRsvModal] = useState<boolean>(false);
  const [selectedRsv, setSelectedRsv] = useState<TReservation>();
  const COLOR_LIST: TColor[] = ["pink", "yellow", "orange", "cyan", "lime", "skyblue", "purple"];
  const [selectedMeetingRoom, setSelectedMeetingRoom] = useState<TMeetingRoom>();
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedStartTime, setSelectedStartTime] = useState<Date>();
  const [selectedEndTime, setSelectedEndTime] = useState<Date>();
  const timeTableRef = useRef<HTMLDivElement>(null);
  const [isRequestCloseRsvModal, setIsRequestCloseRsvModal] = useState<boolean>(false);
  const [isRequestCloseEditRsvModal, setIsRequestCloseEditRsvModal] = useState<boolean>(false);
  const closeRsvCallback = useRef<() => void | undefined>();
  const [isAbleReservation, setIsAbleReservation] = useState<boolean>(false);
  const [openRepeatEditConditionalModal, setOpenRepeatEditConditionalModal] = useState<boolean>(false);
  const [editOption, setEditOption] = useState<RepeatReservationConditionalOption | undefined>(undefined);
  const [editingRsvTitle, setEditingRsvTitle] = useState<string>("");
  const [scrollOffset, setScrollOffset] = useState(0);
  const meetingRoomListRef = useRef<HTMLDivElement>(null);
  const [selectedRsvColor, setSelectedRsvColor] = useState<TColor>("pink");

  //* INFO: Circle 높이 정보
  const overlayHeight = () => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    filteredDate.setHours(0, 0, 0, 0);

    if (filteredDate.getTime() < today.getTime()) {
      return 0.933 * 16 * 60;
    } else if (filteredDate.getTime() === today.getTime()) {
      return 0.933 * getMinutesSince7AM();
    } else {
      return 0.933 * 0;
    }
  };

  //* INFO: 특정 회의실 선택 시, 해당 회의실이 보이는 페이지로 이동
  const goToSelectedMeetingRoom = (meetingRoom?: TMeetingRoom) => {
    if (meetingRoom && show7MeetingRoomList.includes(meetingRoom)) return;
    else if (meetingRoom) {
      const index = showMeetingRoomList.findIndex((item) => item.id === meetingRoom.id);

      if (index < 0) return;
      if (index < 7) {
        setShowStartIndex(0);
        setShowEndIndex(7);
      } else if (index >= 7) {
        if (index >= showMeetingRoomList.length - 7) {
          setShowStartIndex(showMeetingRoomList.length - 7);
          setShowEndIndex(showMeetingRoomList.length);
        } else {
          setShowStartIndex(index - (index % 7));
          setShowEndIndex(index - (index % 7) + 7);
        }
      }
    }
  };

  //* INFO: 선택한 날짜를 문자열로 변환 => ex) 2024.10.11 (화)
  const selectedDataToString = () => {
    const day = ["일", "월", "화", "수", "목", "금", "토"];

    const dateString = `${filteredDate.getFullYear()}. ${(filteredDate.getMonth() + 1)
      .toString()
      .padStart(2, "0")}. ${filteredDate.getDate().toString().padStart(2, "0")} (${day[filteredDate.getDay()]})`;

    return dateString;
  };

  //* INFO: 이전 날짜로 변경
  const setPrevDate = () => {
    const prevDate = new Date(filteredDate);
    prevDate.setDate(prevDate.getDate() - 1);
    updateRsvListByDate(prevDate);
  };

  //* INFO: 날짜 변경 시, 예약 현황을 업데이트
  const updateRsvListByDate = (value: Date) => {
    getRsvList(value);
    setFilteredDate(value);
  };

  //* 조회 일자가 이전 일자인지 확인
  const isPastDate = () => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    filteredDate.setHours(0, 0, 0, 0);

    return filteredDate.getTime() < today.getTime();
  };

  //* 회의실 페이지네이션이 이전 페이지로 이동이 가능한지 확인
  const isAblePrevPage = showStartIndex > 0;

  //* 회의실 페이지네이션이 다음 페이지로 이동이 가능한지 확인
  const isAbleNextPage = showEndIndex < showMeetingRoomList.length;

  useEffect(() => {
    setMeetingRoom(1, locationFilter);
    getBuildingListForLocation().then((res) => {
      if (res.success) {
        setBuildingInfo(res.data ?? []);
      }
    });

    if (timeTableRef.current) {
      timeTableRef.current.scrollTo({ top: getScrollPosition() });
      const handleScroll = () => {
        setScrollOffset(timeTableRef.current?.scrollTop ?? 0);
        if (meetingRoomListRef.current) {
          meetingRoomListRef.current.scrollLeft = timeTableRef.current?.scrollLeft ?? 0;
        }
      };
      timeTableRef.current.addEventListener("scroll", handleScroll);
      return () => timeTableRef.current?.removeEventListener("scroll", handleScroll);
    }
  }, []);

  //* 예약 상세 모달에서, 수정하기 버튼을 눌렀을 경우 호출
  const onOpenEditModal = (reservation?: TReservation, meetingRoom?: TMeetingRoom, isMyReservation?: boolean) => {
    if (openReserVationModal) setIsRequestCloseRsvModal(true);
    if (openEditRsvModal) setIsRequestCloseEditRsvModal(true);

    closeRsvCallback.current = () => {
      if (reservation) setSelectedRsv({ ...reservation, isMyMeeting: isMyReservation ?? false });
      else setSelectedRsv(undefined);
      setSelectedMeetingRoom(meetingRoom);
      setOpenEditRsvModal(true);
    };

    if (!openReserVationModal && !openEditRsvModal) {
      setSelectedMeetingRoom(meetingRoom);
      if (reservation) setSelectedRsv({ ...reservation, isMyMeeting: isMyReservation ?? false });
      else setSelectedRsv(undefined);
      setOpenEditRsvModal(true);
    }
  };

  const onClickEditBtn = (reservation?: TReservation, isMyReservation?: boolean, color?: TColor) => {
    setEditOption(undefined);
    setOpenEditRsvModal(false);
    setSelectedRsvColor(color ?? "pink");

    if (reservation?.isRecurring) {
      //*INFO : 반복 일정 수정시, 반복 예약 수정 조건 모달 오픈
      setOpenRepeatEditConditionalModal(true);
      setSelectedRsv({ ...reservation, isMyMeeting: isMyReservation ?? false });
    } else {
      onOpenEditModal(reservation, reservation?.meetingRoom, isMyReservation);
      setEditingRsvTitle(reservation?.title ?? "");
    }
  };

  const getRsvList = async (date: Date) => {
    setLoading(true);
    const res = await getMeetingReservationList(
      showMeetingRoomList.slice(showStartIndex, showEndIndex).map((item) => item.id),
      date.getFullYear(),
      date.getMonth() + 1,
      date.getDate()
    );
    if (res) {
      const sortedReservationList = show7MeetingRoomList.map((item, index) => {
        return res.data?.find((rsv) => rsv.id === item.id)?.meetingReservations ?? [];
      });
      setRsvList(sortedReservationList);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (showMeetingRoomList.length > 0) getRsvList(filteredDate);
    else setRsvList([]);
  }, [showMeetingRoomList, showStartIndex]);

  const setMeetingRoom = async (page: number, locationFilter: TLocationFilter[]) => {
    const res = await getMeetingRoomList(page, locationFilter, [], 100);
    setMeetingRoomList(res.data?.meetingRoomList ?? []);
    setShoMeetingRoomList(res.data?.meetingRoomList ?? []);
  };

  const show7MeetingRoomList = showMeetingRoomList.slice(showStartIndex, showEndIndex);

  //* 선택된 타임테이블에 예약이 있는지 확인
  useEffect(() => {
    if (selectedMeetingRoom === undefined || selectedStartTime === undefined || selectedEndTime === undefined) {
      setIsAbleReservation(true);
      return;
    }

    const selectedMeetingRoomIndex = show7MeetingRoomList.findIndex((item) => item.id === selectedMeetingRoom?.id);
    if (selectedMeetingRoomIndex < 0) {
      setIsAbleReservation(true);
      return;
    }

    //* 오늘일 경우, 종료시간이 현재 시간보다 이전인지 확인
    if (filteredDate.toDateString() === new Date().toDateString()) {
      const today = new Date();
      const isPastTime =
        selectedEndTime.getHours() < today.getHours()
          ? true
          : selectedEndTime.getHours() === today.getHours()
            ? selectedEndTime.getMinutes() < today.getMinutes()
            : false;
      if (isPastTime) {
        setIsAbleReservation(false);
        return;
      }
    }

    const selectedMeetingRoomRsv = rsvList[selectedMeetingRoomIndex];
    const isOverlap = checkOverlap(
      selectedStartTime,
      selectedEndTime,
      selectedMeetingRoomRsv,
      openEditRsvModal ? selectedRsv : undefined
    );

    setIsAbleReservation(!isOverlap);
  }, [selectedStartTime, selectedEndTime, selectedMeetingRoom, rsvList]);

  return (
    <Container>
      <PageHeader>
        <div className="left-section">
          <PageTitle>
            <div className="title">
              <UI.Typography
                type="title03"
                fontStyle="bold"
                color="var(--alias-color-label-neutral)"
                style={{ whiteSpace: "nowrap" }}
              >
                예약 현황
              </UI.Typography>
              <UI.ToolTip
                text="구글 캘린더를 통해 예약된 회의의 경우, 동기화에 일정 시간이 소요될 수 있습니다."
                position={{ top: 28, left: -103 }}
              >
                <UI.Icon name="info" size={24} color="var(--alias-color-label-assistive)" />
              </UI.ToolTip>
            </div>
            <UI.IconButton.Background
              type="secondary"
              icon="change"
              iconSize={20}
              onClick={() => {
                getRsvList(filteredDate);
              }}
            />
          </PageTitle>
          <PageDate>
            <div className="date-page">
              <UI.IconButton.Normal
                color="var(--alias-color-label-normal)"
                icon="arrowLeft"
                size={20}
                onClick={() => {
                  if (openEditRsvModal) setIsRequestCloseEditRsvModal(true);
                  if (openReserVationModal) setIsRequestCloseRsvModal(true);
                  closeRsvCallback.current = () => {
                    setPrevDate();
                  };

                  if (!openReserVationModal && !openEditRsvModal) setPrevDate();
                }}
              />

              <UI.IconButton.Normal
                icon="arrowRight"
                color="var(--alias-color-label-normal)"
                size={20}
                onClick={() => {
                  if (openEditRsvModal) setIsRequestCloseEditRsvModal(true);
                  if (openReserVationModal) setIsRequestCloseRsvModal(true);

                  const nextDate = new Date(filteredDate);
                  nextDate.setDate(nextDate.getDate() + 1);

                  closeRsvCallback.current = () => {
                    updateRsvListByDate(nextDate);
                  };

                  if (!openEditRsvModal && !openReserVationModal) updateRsvListByDate(nextDate);
                }}
              />
            </div>
            <div style={{ position: "relative" }} onClick={() => setOpenTimeSelector(true)}>
              <UI.ButtonGroups.Text
                iconColor="var(--alias-color-label-neutral)"
                styles={{
                  text: {
                    color: "var(--alias-color-label-neutral)",
                    whiteSpace: "nowrap",
                  },
                }}
                prefixIcon="calendar"
                title={selectedDataToString()}
                showPrefixIcon
                type="secondary"
              />
              <TimeSelectorModal
                open={openTimeSelector}
                setOpen={setOpenTimeSelector}
                value={filteredDate}
                onChange={(date) => {
                  if (openEditRsvModal) setIsRequestCloseEditRsvModal(true);
                  if (openReserVationModal) setIsRequestCloseRsvModal(true);

                  closeRsvCallback.current = () => {
                    updateRsvListByDate(date);
                  };
                  if (!openEditRsvModal && !openReserVationModal) updateRsvListByDate(date);
                }}
              />
            </div>
            <UI.Button
              type="outlined"
              title="오늘"
              size="small"
              style={{ whiteSpace: "nowrap" }}
              primary={false}
              onClick={() => {
                if (openEditRsvModal) setIsRequestCloseEditRsvModal(true);
                if (openReserVationModal) setIsRequestCloseRsvModal(true);
                const today = new Date();
                closeRsvCallback.current = () => {
                  updateRsvListByDate(today);
                };

                if (!openEditRsvModal && !openReserVationModal) {
                  updateRsvListByDate(today);
                  return;
                }
              }}
            />
          </PageDate>
        </div>
        <UI.Button
          onClick={() => {
            setSelectedMeetingRoom(undefined);
            setSelectedStartTime(undefined);
            setOpenReserVationModal(true);
          }}
          type="solid"
          title="예약하기"
          prefixIcon="addCircle"
          showPrefixIcon
          style={{ margin: "0 20px", whiteSpace: "nowrap" }}
        />
        <ReservationModal
          requestClose={isRequestCloseRsvModal}
          closeCallback={closeRsvCallback.current}
          onChangeRequestClose={setIsRequestCloseRsvModal}
          selectedStartTime={selectedStartTime}
          selectedEndTime={selectedEndTime}
          onChangeTime={(startDate, endDate) => {
            if (openReserVationModal) {
              setSelectedStartTime(startDate);
              setSelectedEndTime(endDate);
            }
          }}
          onChangeDate={updateRsvListByDate}
          selectedMeetingRoom={selectedMeetingRoom}
          open={openReserVationModal}
          setOpen={setOpenReserVationModal}
          defaultDate={filteredDate}
          onUpdate={() => getRsvList(filteredDate)}
          onChangeMeetingRoom={(meetingRoom) => {
            goToSelectedMeetingRoom(meetingRoom);
            setSelectedMeetingRoom(meetingRoom);
          }}
          isAbleReservation={isAbleReservation}
        />
        <EditRsvModal
          requestClose={isRequestCloseEditRsvModal}
          closeCallback={closeRsvCallback.current}
          onChangeRequestClose={setIsRequestCloseEditRsvModal}
          selectedMeetingRoom={selectedMeetingRoom}
          onChangeMeetingRoom={(meetingRoom) => {
            goToSelectedMeetingRoom(meetingRoom);
            setSelectedMeetingRoom(meetingRoom);
          }}
          open={openEditRsvModal}
          setOpen={setOpenEditRsvModal}
          orgMeetingRoom={selectedRsv?.meetingRoom}
          onChangeDate={updateRsvListByDate}
          onUpdate={() => getRsvList(filteredDate)}
          defaultDate={filteredDate}
          reservation={selectedRsv}
          selectedStartTime={selectedStartTime}
          selectedEndTime={selectedEndTime}
          onChangeTime={(startDate, endDate) => {
            if (openEditRsvModal) {
              setSelectedStartTime(startDate);
              setSelectedEndTime(endDate);
            }
          }}
          onChangeTitle={setEditingRsvTitle}
          editOption={editOption}
          isAbleReservation={isAbleReservation}
        />
      </PageHeader>
      <FilterContainer>
        <FilterItemContainer>
          <UI.Typography
            type="body01 normal"
            fontStyle="medium"
            color="var(--alias-color-label-normal)"
            style={{
              whiteSpace: "nowrap",
            }}
          >
            회의실 위치
          </UI.Typography>
          <LocationFilter
            onClick={() => {
              if (openReserVationModal) setIsRequestCloseRsvModal(true);
              if (openEditRsvModal) setIsRequestCloseEditRsvModal(true);
              closeRsvCallback.current = () => {};
            }}
            locationData={buildingInfo}
            onChange={(value: LocationDataType[]) => {
              setFilteredMeetingRoomList([]);
              const transformedFilter = value
                //* INFO: 전체 건물 & 전체 층은, item.building.id가 undefined이다. => 전체 건물을 필터에서 없애는 용도
                .filter((item) => item.building === null || item.building?.id !== undefined)
                .map((item: LocationDataType) => {
                  if (item.building === null) return null;
                  else {
                    return {
                      id: item.building?.id ?? "",
                      name: item.building?.name ?? "",
                      floors: item.floor
                        ? item.floor.map((floorItem: { name: string; id: string } | null) => {
                            if (floorItem === null) return null;
                            else
                              return floorItem
                                ? {
                                    id: floorItem?.id ?? "",
                                    name: floorItem?.name ?? "",
                                  }
                                : null;
                          })
                        : [],
                    };
                  }
                });

              setLocationFilter(transformedFilter);
              setMeetingRoom(1, transformedFilter);

              setShowStartIndex(0);
              setShowEndIndex(7);
            }}
          />
        </FilterItemContainer>
        <FilterItemContainer>
          <UI.Typography
            type="body01 normal"
            fontStyle="medium"
            color="var(--alias-color-label-normal)"
            style={{
              whiteSpace: "nowrap",
            }}
          >
            회의실
          </UI.Typography>
          <MeetingRoomFilter
            value={filteredMeetingRoomList}
            onClick={() => {
              if (openReserVationModal) setIsRequestCloseRsvModal(true);
              if (openEditRsvModal) setIsRequestCloseEditRsvModal(true);
              closeRsvCallback.current = () => {};

              setOpenMeetingRoomFilter(true);
            }}
            onChange={(value) => {
              setFilteredMeetingRoomList(value ?? []);

              if (value?.length === 0 || value[0].id === "") {
                setShoMeetingRoomList(meetingRoomList);
              } else {
                setShoMeetingRoomList(value ?? []);
              }
              setShowStartIndex(0);
              setShowEndIndex(7);
            }}
            meetingRoomList={meetingRoomList}
          />
        </FilterItemContainer>
      </FilterContainer>
      <MeetingRoomContainer>
        <ArrowContainer>
          <UI.IconButton.Normal
            color="var(--alias-color-label-normal)"
            disabled={!isAblePrevPage}
            icon="arrowDoubleLeft"
            size={20}
            onClick={() => {
              if (!isAblePrevPage) return;
              setShowStartIndex(0);
              setShowEndIndex(7);
            }}
          />
          <UI.IconButton.Normal
            color="var(--alias-color-label-normal)"
            disabled={!isAblePrevPage}
            icon="arrowLeft"
            size={20}
            onClick={() => {
              if (!isAblePrevPage) return;
              const nextStart = showStartIndex - 7;
              if (nextStart < 0) {
                setShowStartIndex(0);
                setShowEndIndex(7);
              } else {
                setShowStartIndex(nextStart);
                setShowEndIndex(showEndIndex - 7);
              }
            }}
          />
        </ArrowContainer>
        <MeetingRoomListWrapper ref={meetingRoomListRef}>
          <MeetingRoomListContainer>
            {loading &&
              Array.from({ length: 7 }).map((_, index) => (
                <>
                  <MeetingRoomCardSkeleton key={index} />
                  {show7MeetingRoomList.length !== index + 1 && (
                    <div style={{ width: 1, height: 60, background: "var(--alias-color-line-strong" }} />
                  )}
                </>
              ))}
            {!loading &&
              showMeetingRoomList.length > 0 &&
              show7MeetingRoomList.map((meetingRoom, index) => (
                <>
                  <MeetingRoomCard key={`${meetingRoom.id}_${index}`} meetingRoom={meetingRoom} />
                  {show7MeetingRoomList.length !== index + 1 && (
                    <div style={{ width: 1, height: 60, background: "var(--alias-color-line-strong" }} />
                  )}
                </>
              ))}
            {!loading && showMeetingRoomList.length === 0 && (
              <EmptyMeetingRoomList>
                <UI.Icon name="meetingRoom2" size={24} color="var(--alias-color-label-alternative)" />
                <UI.Typography type="body01 normal" fontStyle="regular" color="var(--alias-color-label-normal)">
                  조회할 회의실이 없습니다.
                </UI.Typography>
              </EmptyMeetingRoomList>
            )}
          </MeetingRoomListContainer>
        </MeetingRoomListWrapper>
        <ArrowContainer>
          <UI.IconButton.Normal
            type="primary"
            icon="arrowRight"
            color="var(--alias-color-label-normal)"
            size={20}
            disabled={!isAbleNextPage}
            onClick={() => {
              if (!isAbleNextPage) return;
              const nextEnd = showEndIndex + 7;
              if (nextEnd > showMeetingRoomList.length) {
                setShowEndIndex(showMeetingRoomList.length);
                setShowStartIndex(showMeetingRoomList.length - 7 < 0 ? 0 : showMeetingRoomList.length - 7);
              } else {
                setShowEndIndex(nextEnd);
                setShowStartIndex(showStartIndex + 7);
              }
            }}
          />
          <UI.IconButton.Normal
            color="var(--alias-color-label-normal)"
            icon="arrowDoubleRight"
            size={20}
            disabled={!isAbleNextPage}
            onClick={() => {
              if (!isAbleNextPage) return;
              setShowEndIndex(showMeetingRoomList.length);
              setShowStartIndex(showMeetingRoomList.length - 7 < 0 ? 0 : showMeetingRoomList.length - 7);
            }}
          />
        </ArrowContainer>
      </MeetingRoomContainer>
      {overlayHeight() - scrollOffset + 312 < (timeTableRef.current?.getBoundingClientRect().bottom ?? 0) &&
        overlayHeight() - scrollOffset + 312 > (timeTableRef.current?.getBoundingClientRect().top ?? 0) && (
          <Circle scrollOffset={overlayHeight() - scrollOffset + 317} />
        )}
      <TimeLabelList scrollOffset={scrollOffset} />
      <CenterSideContainer>
        <TimeTableLayout ref={timeTableRef}>
          <TimeTableScrollContainer>
            {loading && <TimeTableSkeleton />}
            {!loading && (
              <MeetingRoomReservationListContainer>
                {showMeetingRoomList.slice(showStartIndex, showEndIndex).map((item, index) => {
                  return (
                    <MeetingRoomReservationList
                      key={`${item.id}_${index}`}
                      selectedDate={filteredDate}
                      isSelectedTimeBlock={!isPastDate()}
                      selectedMeetingRoom={selectedMeetingRoom}
                      isSelectedMeetingRoom={
                        selectedMeetingRoom &&
                        selectedMeetingRoom?.id === showMeetingRoomList[showStartIndex + index]?.id
                          ? true
                          : false
                      }
                      selectedTime={
                        openReserVationModal || openEditRsvModal
                          ? { startDate: selectedStartTime, endDate: selectedEndTime }
                          : undefined
                      }
                      onClickEmptyBlock={(startHour, startMinutes, endHour, endMinutes) => {
                        const startTime = new Date(filteredDate.setHours(startHour, startMinutes));
                        const endTime = new Date(filteredDate.setHours(endHour, endMinutes));

                        //* 빈 시간 블록을 클릭했을 때, 예약 모달을 열고, 해당 시간을 전달
                        if (!openEditRsvModal && !openReserVationModal) {
                          setOpenReserVationModal(true);
                        }
                        setSelectedMeetingRoom(showMeetingRoomList[showStartIndex + index]);
                        setSelectedStartTime(startTime);
                        setSelectedEndTime(endTime);
                      }}
                      onUpdateTimeTable={() => getRsvList(filteredDate)}
                      reservation={rsvList[index]}
                      color={COLOR_LIST[index]}
                      meetingRoom={showMeetingRoomList[showStartIndex + index]}
                      onHandleEdit={(reservation, meetingRoom, isMyReservation) => {
                        onClickEditBtn(reservation, isMyReservation, COLOR_LIST[index]);
                      }}
                      isEditing={openEditRsvModal}
                      selectedRsv={selectedRsv}
                      editingRsvTitle={editingRsvTitle}
                      editRsvColor={selectedRsvColor}
                    />
                  );
                })}
              </MeetingRoomReservationListContainer>
            )}

            <TimeTableUnderLayout filteredDate={filteredDate} />
          </TimeTableScrollContainer>
        </TimeTableLayout>
      </CenterSideContainer>
      <Modals.RepeatEditConditionalModal
        onHandleEdit={(selectedOption) => {
          setEditOption(selectedOption);
          onOpenEditModal(selectedRsv, selectedRsv?.meetingRoom);
          setOpenRepeatEditConditionalModal(false);
        }}
        modalIsOpen={openRepeatEditConditionalModal}
        closeModal={() => setOpenRepeatEditConditionalModal(false)}
      />
    </Container>
  );
};

export default BookingList;
